module.exports = __webpack_public_path__ + "img/orange_033.6a1d785d.png";